import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import Table from '@/components/Table';
import { useFleetAccount } from '@/contexts/fleet-account/useFleetAccount';
import { getLatestActiveStateQueryOptions } from '@/service/vpc/queryOptions';
import useFaultCodesTable from '@/tables/useFaultCodesTable';
import { chassis } from '@/utils';

export const Route = createFileRoute('/_authenticated/_account/dashboard/active-fault-codes/')({
  component: ActiveFaultCodesPage,
  errorComponent: ErrorBoundary,
});

function ActiveFaultCodesPage() {
  const { t } = useTranslation();
  const { isLoading: isFleetUnitsLoading, fleetVerifiedUnits } = useFleetAccount();
  const { columns } = useFaultCodesTable(fleetVerifiedUnits);

  const chassisIds = chassis.extractChassisIdsCsv(fleetVerifiedUnits);

  const { data: activeFaultCodes, isLoading } = useQuery(
    getLatestActiveStateQueryOptions({ chassisIds, pageSize: 100, pageNumber: 1 })
  );

  return (
    <Table
      headerTitle={t(($) => $.pages.account.dashboard.active_fault_codes.units_title)}
      isLoading={isFleetUnitsLoading || isLoading}
      data={activeFaultCodes || []}
      columns={columns}
      showSearch={true}
    />
  );
}
